import SearchBox from "../components/SearchBox";
import backgroundMobile from "../assets/images/homepage-banner-mobile.jpg?v=2";
import backgroundDesktop from "../assets/images/homepage-banner-desktop.jpg?v=2";
import { T } from "@tolgee/react";
import useAppState from "../store/appState";
import { useEffect, useState } from "react";

function HomePage() {
  const { isMobile } = useAppState();
  const [vectorSearch, setVectorSearch] = useState(localStorage["vectorSearch"] == "true");

  useEffect(() => {
    localStorage.setItem("vectorSearch", vectorSearch);
  }, [vectorSearch]);

  return (
    <section className="bg-white">
      <div className="relative">
        <img className=" w-full" src={isMobile ? backgroundMobile : backgroundDesktop} alt="Background"></img>
        <div className="w-full px-4 lg:px-0 mx-auto mt-[27px] lg:absolute text-black lg:text-grey-1-sp font-roboto md:items-center flex flex-col lg:translate-x-[-50%] lg:translate-y-[-50%] lg:top-[44%] lg:left-1/2">
          <p className="leading-[48px] lg:leading-[70px] text-[42px] lg:text-[64px] font-semibold lg:drop-shadow-lg">
            {isMobile ? <T keyName="HomePage.h1.title.mobile" /> : <T keyName="HomePage.h1.title.desktop" />}
          </p>
          <h2 className="leading-[24px] mt-[17px]  lg:mb-[28px] lg:mt-[11px] text-[18px] lg:text-[24px] font-medium lg:drop-shadow-lg ">
            <T keyName="HomePage.h2.subtitle" />
          </h2>
          <div className="mt-[33px] mb-[128px] lg:mb-[0px] lg:mt-[0px] flex flex-col md:flex-row">
            <SearchBox smartSearch={vectorSearch} />
            <div className="flex items-center justify-between gap-3 bg-[#ffffff30] backdrop-blur-[6px] border-2 border-gray-2 rounded-[50px] h-[58px] px-3 w-[200px]">
              <div>
                <label id="smart-search-label" className="text-[16px] leading-5 font-semibold font-roboto">
                  <T keyName="ResultsPage.SmartSearch" />
                </label>
              </div>

              <div className="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 outline-offset-2 outline-[#ea2c14] ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out has-[:checked]:bg-[#ea2c14] has-[:focus-visible]:outline has-[:focus-visible]:outline-2">
                <span className="size-5 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-[:checked]:translate-x-5" />
                <input
                  id="smart-search"
                  name="smart-search"
                  type="checkbox"
                  aria-labelledby="smart-search-label"
                  aria-describedby="smart-search-description"
                  className="absolute inset-0 size-full appearance-none focus:outline-none"
                  onChange={(e) => setVectorSearch(e.target.checked)}
                  checked={vectorSearch}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomePage;
